'use client';

import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * The bar along a toast's bottom edge that shrinks to nothing over the time
 * left before the toast hides itself. The toast needs `position: relative`.
 */
export function ToastTimer({
  duration,
  color,
}: {
  duration: number;
  /** A palette path such as `success.main`. */
  color: string;
}) {
  const [progress, setProgress] = useState(100);

  // Start full, then let the width transition run down to empty.
  useEffect(() => {
    setProgress(100);
    const timeout = setTimeout(() => setProgress(0), 10);
    return () => clearTimeout(timeout);
  }, [duration]);

  return (
    <Box
      sx={{
        height: '3px',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: color,
        transition: `width ${duration}ms linear`,
        width: `${progress}%`,
      }}
    />
  );
}
